module.exports = __webpack_public_path__ + "web.config";


//////////////////
// WEBPACK FOOTER
// ./src/web.config
// module id = 1212
// module chunks = 0